module.exports = __webpack_public_path__ + "img/tour-23.96f7a7f9.png";